/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_6_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_6_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a download without guessing`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_6_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有依据地选择下载文件`)
};

/**
* | output |
* | --- |
* | "Choose a download without guessing" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_6_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_6_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_6_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_6_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_6_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_6_title as "gc.search_guides.what_is_gridcraft.sections.6.title" }